<template>
  <div>
    <div class="section-header">
      <span class="section-bar" />
      <span class="section-title">
        {{ $l('section_goods_list') || '产品清单' }}
      </span>
    </div>

    <PageMain
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @editCustoms="openEditCustoms"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
    </PageMain>

    <EditGoodsCustoms
      :visible.sync="editCustomsVisible"
      :shipmentGoodsCode="currentShipmentGoodsCode"
      @reload="reload"
    />
  </div>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageMain from './main.vue'
import EditGoodsCustoms from '../edit-goods-customs/index.vue'

export default {
  components: { PageHeader, PageMain, EditGoodsCustoms },
  mixins: [BaseTable],
  props: {
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      usePage: false,
      editCustomsVisible: false,
      currentShipmentGoodsCode: '',
    }
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .ecomShipmentGoodsListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    openEditCustoms(row) {
      this.currentShipmentGoodsCode = row.shipmentGoodsCode || ''
      this.editCustomsVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.section-bar {
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #409eff;
  flex-shrink: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}
</style>
